import { useEffect, useState } from 'react';
import pill1Image from '../assets/images/pill/Pill1.png';
import pill2Image from '../assets/images/pill/Pill2.png';
import pill3Image from '../assets/images/pill/Pill3.png';
import pill4Image from '../assets/images/pill/Pill4.png';
import pillBox from '../assets/images/pill/Box.png';
import buttonUrl from '../assets/images/Button.png';
import backgroundUrl from '../assets/images/background.png';
import pawUrl from '../assets/images/paw2.png';
import bookBackgroundUrl from '../assets/images/diary.png';
import prescriptionBackgroundUrl from '../assets/images/prescription.png';
import prescriptionPreviewBackgroundUrl from '../assets/images/prescription_preview.png';
import buttonCrossUrl from '../assets/images/cross.png';
import pillboxBackground from '../assets/images/pillbox/pillbox.png';
import morningBackground from '../assets/images/pillbox/morning.png';
import forenoonBackground from '../assets/images/pillbox/forenoon.png';
import noonBackground from '../assets/images/pillbox/noon.png';
import afternoonBackground from '../assets/images/pillbox/afternoon.png';
import eveningBackground from '../assets/images/pillbox/evening.png';
import nightBackground from '../assets/images/pillbox/night.png';
import menuBackground from '../assets/images/main_menu.png';
import music from '../assets/music/Level.wav';

export const preload = (resources: string[], signal: AbortSignal|undefined, onProgress?: (progress: number) => void): Promise<void> => {
    return new Promise(res => {
        let waiting = resources.length;
        resources.forEach(r => {
            if (r.endsWith('.png')) {
                const i = new Image();
                i.onerror = i.onload = () => {
                    waiting--;
                    onProgress?.(waiting / resources.length);
                    if (waiting === 0) {
                        res();
                    }
                };
                i.src = r;
            } else {
                fetch(r, {
                    signal,
                }).catch(console.warn).then(() => {
                    waiting--;
                    onProgress?.(waiting / resources.length);
                    if (waiting === 0) {
                        res();
                    }
                });
            }
        });
    });
};

export const useLoader = (resources: string[]): [boolean, number] => {
    const [ progress, setProgress ] = useState(0);
    const [ loaded, setLoaded ] = useState(false);
    useEffect(() => {
        const controller = new AbortController();
        preload(resources, controller.signal, setProgress)
            .then(() => {
                setLoaded(true);
            });
    }, [ resources ]);
    return [ loaded, progress ];
};

export const loadableResources: string[] = [
    pill1Image,
    pill2Image,
    pill3Image,
    pill4Image,
    pillBox,
    buttonUrl,
    backgroundUrl,
    pawUrl,
    bookBackgroundUrl,
    prescriptionBackgroundUrl,
    prescriptionPreviewBackgroundUrl,
    buttonCrossUrl,
    pillboxBackground,
    morningBackground,
    forenoonBackground,
    noonBackground,
    afternoonBackground,
    eveningBackground,
    nightBackground,
    menuBackground,
];
